var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndividuals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 24,
    viewBox: "0 0 21 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74878 4V2C6.74878 1.45 6.94478 0.979 7.33678 0.587C7.72811 0.195667 8.19878 0 8.74878 0H12.7488C13.2988 0 13.7698 0.195667 14.1618 0.587C14.5531 0.979 14.7488 1.45 14.7488 2V4H18.7488C19.2988 4 19.7698 4.196 20.1618 4.588C20.5531 4.97933 20.7488 5.45 20.7488 6V11H13.7488V9H7.74878V11H0.748779V6C0.748779 5.45 0.944779 4.97933 1.33678 4.588C1.72811 4.196 2.19878 4 2.74878 4H6.74878ZM8.74878 4H12.7488V2H8.74878V4ZM9.74878 13V11H11.7488V13H9.74878ZM0.748779 13H7.74878V15H13.7488V13H20.7488V17C20.7488 17.55 20.5531 18.021 20.1618 18.413C19.7698 18.8043 19.2988 19 18.7488 19H2.74878C2.19878 19 1.72811 18.8043 1.33678 18.413C0.944779 18.021 0.748779 17.55 0.748779 17V13Z",
    fill: "",
    fillOpacity: 0.92
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividuals);
export default __webpack_public_path__ + "static/media/individuals.fbd01feaedc70980bd85a98c2c7bc073.svg";
export { ForwardRef as ReactComponent };